<template>
    <v-slide-y-transition>
        <v-card
                :color="notification.type"
                class="notification white--text"
                v-touch="{
                      left: () => swipe('Left'),
                      right: () => swipe('Right'),
                      up: () => swipe('Up'),
                      down: () => swipe('Down')
                }"
                v-show="!hideNotification"
        >
            <v-card-title class="pl-3 pr-0 pb-0 pt-1">
                <v-icon left>
                    {{ notification.icon }}
                </v-icon>
                <span class="subheading"><strong>{{ notification.title }}</strong></span>
                <v-spacer/>
                <span
                        v-if="!notification.dismissible"
                        class="mr-4"
                ><strong>{{ notification.time }}</strong></span>
                <span v-else><strong>{{ notification.time }}</strong></span>
                <v-btn
                        v-if="notification.dismissible"
                        flat
                        small
                        icon
                        color="white"
                        @click="dismissNotification()"
                >
                    <v-icon>mdi-close-circle</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text
                    class="pl-3 pr-2 pb-2 pt-0"
                    @click="isPanelClosed = !isPanelClosed"
            >
                <!-- COLLAPSED BODY -->
                <div v-if="notification.message !== undefined && notification.message.length > 100">
                    <!-- header -->
                    <v-expand-transition>
                        <div
                                v-show="isPanelClosed"
                                class="pa-0"
                        >
                            <div>{{ shortenMessage }}</div>
                        </div>
                    </v-expand-transition>
                    <!-- body -->
                    <v-expand-transition>
                        <div
                                v-show="!isPanelClosed"
                                class="pa-0"
                        >
                            <div v-html="htmlMessage"></div>
                        </div>
                    </v-expand-transition>

                    <v-flex
                            xs12
                            class="pa-0"
                    >
                        <v-layout
                                row
                                wrap
                                class="pa-0"
                                align-center
                                justify-center
                        >
                            <v-flex
                                    v-if="isPanelClosed"
                                    shrink
                            >
                                <strong>{{ $t('globalControls.notifications.content.showMore') }}</strong>
                            </v-flex>
                            <v-flex
                                    v-else
                                    shrink
                            >
                                <strong>{{ $t('globalControls.notifications.content.showLess') }}</strong>
                            </v-flex>
                            <v-spacer/>
                            <v-flex
                                    v-if="isPanelClosed"
                                    shrink
                            >
                                <v-icon
                                        right
                                        class="white--text"
                                >
                                    keyboard_arrow_down
                                </v-icon>
                            </v-flex>
                            <v-flex
                                    v-else
                                    shrink
                            >
                                <v-icon
                                        right
                                        class="white--text"
                                >
                                    keyboard_arrow_up
                                </v-icon>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </div>
                <!-- TOTAL BODY -->
                <div v-else>
                    {{ notification.message }}
                </div>
                <v-progress-linear
                        v-if="notification.loading"
                        indeterminate
                        color="white"
                        class="mb-0"
                />
            </v-card-text>
            <v-card-actions v-if="notification.actions !== undefined && notification.actions.length > 0">
                <v-btn
                        v-for="action in notification.actions"
                        flat
                        dark
                        @click="dismissNotification(notification)"
                >
                    {{ action.name }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-slide-y-transition>
</template>
<script>
    import NotificationService from "@/helpers/NotificationService";

    export default {
        name: "Notification",
        props: ["notification"],
        data() {
            return {
                isPanelClosed: true,
                hideNotification: false
            };
        },
        computed: {
            shortenMessage() {
                return this.notification.message.substring(0, 70) + "...";
            },
            htmlMessage() {
                let finalMessage = "";
                let messageList = this.notification.message.split(", ");
                if (messageList.length === 1) {
                    finalMessage = messageList[0];
                } else {
                    for (let i = 0; i < messageList.length; i++) {
                        finalMessage = finalMessage + `<p class="ma-0 pa-0">${messageList[i]}</p>`;
                    }
                }
                let html = `<div class="ma-0 pa-0">${finalMessage}</div>`;
                return html;
            },
        },
        methods: {
            dismissNotification() {
                NotificationService.dismissNotification(this.notification.id);
            },
            swipe (direction) {
                if (direction === "Left" || direction === "Right") {
                    if (!this.notification.loading) {
                        NotificationService.expireNotification(this.notification.id);
                    }
                } else if (direction === "Up") {
                    this.hideNotification = true;
                } else {

                }
            }
        },
    };
</script>

<style lang="scss" scoped>
    .notification {
        border-radius: 5px;
    }
</style>
